/**
 * Prize Pop Rules Tab (campaign variant)
 * Composes the shared CampaignRulesTab shell with the prize pop-specific sections
 */

import { memo, type FC } from 'react';

import { RulesTab as CampaignRulesTab } from '../../../../shared/tabs';
import { PrizePopRulesContent } from './PrizePopRulesContent/PrizePopRulesContent';

const RulesTab: FC = () => <CampaignRulesTab Content={PrizePopRulesContent} />;

export default memo(RulesTab);
